/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CreateDocumentRequest = {
    properties: {
        name: {
    type: 'string',
    isRequired: true,
},
    },
};